import React from "react";
import { Box } from "@mui/material";
import styled from "styled-components";
import { FeatureSubtext } from "./FeatureSubtext";
import { LocationCard } from "./LocationCard";
import { StyleCard } from "./StyleCard";
import { SizeCard } from "./SizeCard";

const FeatureCardsContainer = styled(Box)`
  width: 100%;
  padding: 80px 0;
  background-color: ${props => props.theme.palette.background.default};
`;

const CardsGrid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
`;

export const FeatureCards: React.FC = () => {
  return (
    <FeatureCardsContainer>
      <FeatureSubtext />
      <CardsGrid>
          <LocationCard />
          <StyleCard />
          <SizeCard />
      </CardsGrid>
    </FeatureCardsContainer>
  );
};
